unit View.Grade_Produtos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewGrade_ProdutosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbgrade_linha_id: TLabel;
    edgrade_linha_id: TDBEdit;
    lbgrade_coluna_id: TLabel;
    edgrade_coluna_id: TDBEdit;
    lbprodutos_id: TLabel;
    edprodutos_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_barras: TLabel;
    edcodigo_barras: TDBEdit;
    lbcodigo_fabrica: TLabel;
    edcodigo_fabrica: TDBEdit;
    lbestoque: TLabel;
    edestoque: TDBEdit;
    lbestoque_retido: TLabel;
    edestoque_retido: TDBEdit;
    lbestoque_maximo: TLabel;
    edestoque_maximo: TDBEdit;
    lbestoque_minimo: TLabel;
    edestoque_minimo: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientGrade_ProdutosGet: TXDataWebClient;
    XDataClientGrade_ProdutosDelete: TXDataWebClient;
    Grade_ProdutosDataset: TXDataWebDataSet;
    Grade_ProdutosDatasetid: TIntegerField;
    Grade_ProdutosDatasetaliado_id: TIntegerField;
    Grade_ProdutosDatasetdata_base_id: TIntegerField;
    Grade_ProdutosDatasetgrade_linha_id: TIntegerField;
    Grade_ProdutosDatasetgrade_coluna_id: TIntegerField;
    Grade_ProdutosDatasetprodutos_id: TIntegerField;
    Grade_ProdutosDatasetnome: TStringField;
    Grade_ProdutosDatasetcodigo_barras: TStringField;
    Grade_ProdutosDatasetcodigo_fabrica: TStringField;
    Grade_ProdutosDatasetestoque: TFloatField;
    Grade_ProdutosDatasetestoque_retido: TFloatField;
    Grade_ProdutosDatasetestoque_maximo: TFloatField;
    Grade_ProdutosDatasetestoque_minimo: TFloatField;
    Grade_ProdutosDatasetstatus: TIntegerField;
    Grade_ProdutosDatasetcadastro: TDateTimeField;
    Grade_ProdutosDatasetcodigo_interno: TIntegerField;
    Grade_ProdutosDatasetexcluido: TBooleanField;
    Grade_ProdutosDatasetinclusao: TDateTimeField;
    Grade_ProdutosDatasetalteracao: TDateTimeField;
    Grade_ProdutosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientGrade_ProdutosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_ProdutosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_ProdutosDeleteError(Error: TXDataClientError);
    procedure Grade_ProdutosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_ProdutosEdit: TFViewGrade_ProdutosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_ProdutosEdit }

procedure TFViewGrade_ProdutosEdit.btSaveClick(Sender: TObject);
begin
  if Grade_ProdutosDataset.State in dsEditModes then
  begin
        Grade_ProdutosDataset.Post;
    Grade_ProdutosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewGrade_ProdutosEdit.btDeleteClick(Sender: TObject);
begin
  if Grade_ProdutosDataset.State in dsEditModes then
    Grade_ProdutosDataset.Post;
  XDataClientGrade_ProdutosDelete.Delete(Grade_ProdutosDataset.EntitySetName,
    TJSObject(Grade_ProdutosDataset.CurrentData));
end;


class function TFViewGrade_ProdutosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewGrade_ProdutosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewGrade_ProdutosEdit.InsertEntity;
begin
  Grade_ProdutosDataset.Close;
  Grade_ProdutosDataset.SetJsonData('{}');
  Grade_ProdutosDataset.Open;
  Grade_ProdutosDataset.Insert;
end;

class function TFViewGrade_ProdutosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_ProdutosEdit(AForm).FInserting := AInserting;
    TFViewGrade_ProdutosEdit(AForm).FId := AId;
    TFViewGrade_ProdutosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewGrade_ProdutosEdit(AForm).InsertEntity
    else
      TFViewGrade_ProdutosEdit(AForm).LoadEntity;
    TFViewGrade_ProdutosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewGrade_ProdutosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_ProdutosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Grade_ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Grade_ProdutosDataset.EntitySetName
    )
  );
  XDataClientGrade_ProdutosGet.Get(Grade_ProdutosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewGrade_ProdutosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewGrade_ProdutosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_ProdutosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_ProdutosEdit.XDataClientGrade_ProdutosGetLoad(Response: TXDataClientResponse);
begin
  Grade_ProdutosDataset.Close;
  Grade_ProdutosDataset.SetJsonData(Response.Result);
  Grade_ProdutosDataset.Open;
  
  Grade_ProdutosDataset.Edit;  
end;

procedure TFViewGrade_ProdutosEdit.XDataClientGrade_ProdutosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGrade_ProdutosEdit.XDataClientGrade_ProdutosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewGrade_ProdutosEdit.Grade_ProdutosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewGrade_ProdutosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewGrade_ProdutosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.grade_produtos.form.message');
  lbMessage := TLabel.Create('view.grade_produtos.form.message.label');
  btCloseMessage := TButton.Create('view.grade_produtos.form.message.button');
  btCancel := TButton.Create('view.grade_produtos.form.btBack');
  btSave := TButton.Create('view.grade_produtos.form.btSave');
  btDelete := TButton.Create('view.grade_produtos.form.btDelete');
  lbid := TLabel.Create('view.grade_produtos.form.lbid');
  edid := TDBEdit.Create('view.grade_produtos.form.edid');
  lbaliado_id := TLabel.Create('view.grade_produtos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.grade_produtos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.grade_produtos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.grade_produtos.form.eddata_base_id');
  lbgrade_linha_id := TLabel.Create('view.grade_produtos.form.lbgrade_linha_id');
  edgrade_linha_id := TDBEdit.Create('view.grade_produtos.form.edgrade_linha_id');
  lbgrade_coluna_id := TLabel.Create('view.grade_produtos.form.lbgrade_coluna_id');
  edgrade_coluna_id := TDBEdit.Create('view.grade_produtos.form.edgrade_coluna_id');
  lbprodutos_id := TLabel.Create('view.grade_produtos.form.lbprodutos_id');
  edprodutos_id := TDBEdit.Create('view.grade_produtos.form.edprodutos_id');
  lbnome := TLabel.Create('view.grade_produtos.form.lbnome');
  ednome := TDBEdit.Create('view.grade_produtos.form.ednome');
  lbcodigo_barras := TLabel.Create('view.grade_produtos.form.lbcodigo_barras');
  edcodigo_barras := TDBEdit.Create('view.grade_produtos.form.edcodigo_barras');
  lbcodigo_fabrica := TLabel.Create('view.grade_produtos.form.lbcodigo_fabrica');
  edcodigo_fabrica := TDBEdit.Create('view.grade_produtos.form.edcodigo_fabrica');
  lbestoque := TLabel.Create('view.grade_produtos.form.lbestoque');
  edestoque := TDBEdit.Create('view.grade_produtos.form.edestoque');
  lbestoque_retido := TLabel.Create('view.grade_produtos.form.lbestoque_retido');
  edestoque_retido := TDBEdit.Create('view.grade_produtos.form.edestoque_retido');
  lbestoque_maximo := TLabel.Create('view.grade_produtos.form.lbestoque_maximo');
  edestoque_maximo := TDBEdit.Create('view.grade_produtos.form.edestoque_maximo');
  lbestoque_minimo := TLabel.Create('view.grade_produtos.form.lbestoque_minimo');
  edestoque_minimo := TDBEdit.Create('view.grade_produtos.form.edestoque_minimo');
  lbstatus := TLabel.Create('view.grade_produtos.form.lbstatus');
  edstatus := TDBEdit.Create('view.grade_produtos.form.edstatus');
  lbcadastro := TLabel.Create('view.grade_produtos.form.lbcadastro');
  edcadastro := TDBEdit.Create('view.grade_produtos.form.edcadastro');
  lbcodigo_interno := TLabel.Create('view.grade_produtos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.grade_produtos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.grade_produtos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.grade_produtos.form.edexcluido');
  lbinclusao := TLabel.Create('view.grade_produtos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.grade_produtos.form.edinclusao');
  lbalteracao := TLabel.Create('view.grade_produtos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.grade_produtos.form.edalteracao');
  lbexclusao := TLabel.Create('view.grade_produtos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.grade_produtos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Grade_ProdutosDataset := TXDataWebDataSet.Create(Self);
  Grade_ProdutosDatasetid := TIntegerField.Create(Self);
  Grade_ProdutosDatasetaliado_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetgrade_linha_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetgrade_coluna_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetprodutos_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetnome := TStringField.Create(Self);
  Grade_ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  Grade_ProdutosDatasetcodigo_fabrica := TStringField.Create(Self);
  Grade_ProdutosDatasetestoque := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_retido := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_maximo := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_minimo := TFloatField.Create(Self);
  Grade_ProdutosDatasetstatus := TIntegerField.Create(Self);
  Grade_ProdutosDatasetcadastro := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_ProdutosDatasetexcluido := TBooleanField.Create(Self);
  Grade_ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientGrade_ProdutosGet := TXDataWebClient.Create(Self);
  XDataClientGrade_ProdutosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbgrade_linha_id.BeforeLoadDFMValues;
  edgrade_linha_id.BeforeLoadDFMValues;
  lbgrade_coluna_id.BeforeLoadDFMValues;
  edgrade_coluna_id.BeforeLoadDFMValues;
  lbprodutos_id.BeforeLoadDFMValues;
  edprodutos_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo_barras.BeforeLoadDFMValues;
  edcodigo_barras.BeforeLoadDFMValues;
  lbcodigo_fabrica.BeforeLoadDFMValues;
  edcodigo_fabrica.BeforeLoadDFMValues;
  lbestoque.BeforeLoadDFMValues;
  edestoque.BeforeLoadDFMValues;
  lbestoque_retido.BeforeLoadDFMValues;
  edestoque_retido.BeforeLoadDFMValues;
  lbestoque_maximo.BeforeLoadDFMValues;
  edestoque_maximo.BeforeLoadDFMValues;
  lbestoque_minimo.BeforeLoadDFMValues;
  edestoque_minimo.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Grade_ProdutosDataset.BeforeLoadDFMValues;
  Grade_ProdutosDatasetid.BeforeLoadDFMValues;
  Grade_ProdutosDatasetaliado_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetgrade_linha_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetgrade_coluna_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetprodutos_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetnome.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_fabrica.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_retido.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_maximo.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_minimo.BeforeLoadDFMValues;
  Grade_ProdutosDatasetstatus.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcadastro.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_ProdutosDatasetexcluido.BeforeLoadDFMValues;
  Grade_ProdutosDatasetinclusao.BeforeLoadDFMValues;
  Grade_ProdutosDatasetalteracao.BeforeLoadDFMValues;
  Grade_ProdutosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientGrade_ProdutosGet.BeforeLoadDFMValues;
  XDataClientGrade_ProdutosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_ProdutosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 805;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 745;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 745;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 745;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbgrade_linha_id.SetParentComponent(Self);
    lbgrade_linha_id.Name := 'lbgrade_linha_id';
    lbgrade_linha_id.Left := 24;
    lbgrade_linha_id.Top := 273;
    lbgrade_linha_id.Width := 14;
    lbgrade_linha_id.Height := 13;
    lbgrade_linha_id.Caption := 'grade_linha_id:';
    lbgrade_linha_id.Transparent := True;
    edgrade_linha_id.SetParentComponent(Self);
    edgrade_linha_id.Name := 'edgrade_linha_id';
    edgrade_linha_id.Left := 221;
    edgrade_linha_id.Top := 270;
    edgrade_linha_id.Width := 200;
    edgrade_linha_id.Height := 21;
    edgrade_linha_id.Enabled := True;
    edgrade_linha_id.TabOrder := 9;
    edgrade_linha_id.Text := 'edgrade_linha_id';
    edgrade_linha_id.DataField := 'grade_linha_id';
    edgrade_linha_id.DataSource := DataSource;
    lbgrade_coluna_id.SetParentComponent(Self);
    lbgrade_coluna_id.Name := 'lbgrade_coluna_id';
    lbgrade_coluna_id.Left := 24;
    lbgrade_coluna_id.Top := 300;
    lbgrade_coluna_id.Width := 14;
    lbgrade_coluna_id.Height := 13;
    lbgrade_coluna_id.Caption := 'grade_coluna_id:';
    lbgrade_coluna_id.Transparent := True;
    edgrade_coluna_id.SetParentComponent(Self);
    edgrade_coluna_id.Name := 'edgrade_coluna_id';
    edgrade_coluna_id.Left := 221;
    edgrade_coluna_id.Top := 297;
    edgrade_coluna_id.Width := 200;
    edgrade_coluna_id.Height := 21;
    edgrade_coluna_id.Enabled := True;
    edgrade_coluna_id.TabOrder := 10;
    edgrade_coluna_id.Text := 'edgrade_coluna_id';
    edgrade_coluna_id.DataField := 'grade_coluna_id';
    edgrade_coluna_id.DataSource := DataSource;
    lbprodutos_id.SetParentComponent(Self);
    lbprodutos_id.Name := 'lbprodutos_id';
    lbprodutos_id.Left := 24;
    lbprodutos_id.Top := 327;
    lbprodutos_id.Width := 14;
    lbprodutos_id.Height := 13;
    lbprodutos_id.Caption := 'produtos_id:';
    lbprodutos_id.Transparent := True;
    edprodutos_id.SetParentComponent(Self);
    edprodutos_id.Name := 'edprodutos_id';
    edprodutos_id.Left := 221;
    edprodutos_id.Top := 324;
    edprodutos_id.Width := 200;
    edprodutos_id.Height := 21;
    edprodutos_id.Enabled := True;
    edprodutos_id.TabOrder := 11;
    edprodutos_id.Text := 'edprodutos_id';
    edprodutos_id.DataField := 'produtos_id';
    edprodutos_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 354;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 351;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 12;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo_barras.SetParentComponent(Self);
    lbcodigo_barras.Name := 'lbcodigo_barras';
    lbcodigo_barras.Left := 24;
    lbcodigo_barras.Top := 381;
    lbcodigo_barras.Width := 14;
    lbcodigo_barras.Height := 13;
    lbcodigo_barras.Caption := 'codigo_barras:';
    lbcodigo_barras.Transparent := True;
    edcodigo_barras.SetParentComponent(Self);
    edcodigo_barras.Name := 'edcodigo_barras';
    edcodigo_barras.Left := 221;
    edcodigo_barras.Top := 378;
    edcodigo_barras.Width := 200;
    edcodigo_barras.Height := 21;
    edcodigo_barras.Enabled := True;
    edcodigo_barras.TabOrder := 13;
    edcodigo_barras.Text := 'edcodigo_barras';
    edcodigo_barras.DataField := 'codigo_barras';
    edcodigo_barras.DataSource := DataSource;
    lbcodigo_fabrica.SetParentComponent(Self);
    lbcodigo_fabrica.Name := 'lbcodigo_fabrica';
    lbcodigo_fabrica.Left := 24;
    lbcodigo_fabrica.Top := 408;
    lbcodigo_fabrica.Width := 14;
    lbcodigo_fabrica.Height := 13;
    lbcodigo_fabrica.Caption := 'codigo_fabrica:';
    lbcodigo_fabrica.Transparent := True;
    edcodigo_fabrica.SetParentComponent(Self);
    edcodigo_fabrica.Name := 'edcodigo_fabrica';
    edcodigo_fabrica.Left := 221;
    edcodigo_fabrica.Top := 405;
    edcodigo_fabrica.Width := 200;
    edcodigo_fabrica.Height := 21;
    edcodigo_fabrica.Enabled := True;
    edcodigo_fabrica.TabOrder := 14;
    edcodigo_fabrica.Text := 'edcodigo_fabrica';
    edcodigo_fabrica.DataField := 'codigo_fabrica';
    edcodigo_fabrica.DataSource := DataSource;
    lbestoque.SetParentComponent(Self);
    lbestoque.Name := 'lbestoque';
    lbestoque.Left := 24;
    lbestoque.Top := 435;
    lbestoque.Width := 14;
    lbestoque.Height := 13;
    lbestoque.Caption := 'estoque:';
    lbestoque.Transparent := True;
    edestoque.SetParentComponent(Self);
    edestoque.Name := 'edestoque';
    edestoque.Left := 221;
    edestoque.Top := 432;
    edestoque.Width := 200;
    edestoque.Height := 21;
    edestoque.Enabled := True;
    edestoque.TabOrder := 15;
    edestoque.Text := 'edestoque';
    edestoque.DataField := 'estoque';
    edestoque.DataSource := DataSource;
    lbestoque_retido.SetParentComponent(Self);
    lbestoque_retido.Name := 'lbestoque_retido';
    lbestoque_retido.Left := 24;
    lbestoque_retido.Top := 462;
    lbestoque_retido.Width := 14;
    lbestoque_retido.Height := 13;
    lbestoque_retido.Caption := 'estoque_retido:';
    lbestoque_retido.Transparent := True;
    edestoque_retido.SetParentComponent(Self);
    edestoque_retido.Name := 'edestoque_retido';
    edestoque_retido.Left := 221;
    edestoque_retido.Top := 459;
    edestoque_retido.Width := 200;
    edestoque_retido.Height := 21;
    edestoque_retido.Enabled := True;
    edestoque_retido.TabOrder := 16;
    edestoque_retido.Text := 'edestoque_retido';
    edestoque_retido.DataField := 'estoque_retido';
    edestoque_retido.DataSource := DataSource;
    lbestoque_maximo.SetParentComponent(Self);
    lbestoque_maximo.Name := 'lbestoque_maximo';
    lbestoque_maximo.Left := 24;
    lbestoque_maximo.Top := 489;
    lbestoque_maximo.Width := 14;
    lbestoque_maximo.Height := 13;
    lbestoque_maximo.Caption := 'estoque_maximo:';
    lbestoque_maximo.Transparent := True;
    edestoque_maximo.SetParentComponent(Self);
    edestoque_maximo.Name := 'edestoque_maximo';
    edestoque_maximo.Left := 221;
    edestoque_maximo.Top := 486;
    edestoque_maximo.Width := 200;
    edestoque_maximo.Height := 21;
    edestoque_maximo.Enabled := True;
    edestoque_maximo.TabOrder := 17;
    edestoque_maximo.Text := 'edestoque_maximo';
    edestoque_maximo.DataField := 'estoque_maximo';
    edestoque_maximo.DataSource := DataSource;
    lbestoque_minimo.SetParentComponent(Self);
    lbestoque_minimo.Name := 'lbestoque_minimo';
    lbestoque_minimo.Left := 24;
    lbestoque_minimo.Top := 516;
    lbestoque_minimo.Width := 14;
    lbestoque_minimo.Height := 13;
    lbestoque_minimo.Caption := 'estoque_minimo:';
    lbestoque_minimo.Transparent := True;
    edestoque_minimo.SetParentComponent(Self);
    edestoque_minimo.Name := 'edestoque_minimo';
    edestoque_minimo.Left := 221;
    edestoque_minimo.Top := 513;
    edestoque_minimo.Width := 200;
    edestoque_minimo.Height := 21;
    edestoque_minimo.Enabled := True;
    edestoque_minimo.TabOrder := 18;
    edestoque_minimo.Text := 'edestoque_minimo';
    edestoque_minimo.DataField := 'estoque_minimo';
    edestoque_minimo.DataSource := DataSource;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 24;
    lbstatus.Top := 543;
    lbstatus.Width := 14;
    lbstatus.Height := 13;
    lbstatus.Caption := 'status:';
    lbstatus.Transparent := True;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 221;
    edstatus.Top := 540;
    edstatus.Width := 200;
    edstatus.Height := 21;
    edstatus.Enabled := True;
    edstatus.TabOrder := 19;
    edstatus.Text := 'edstatus';
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 24;
    lbcadastro.Top := 570;
    lbcadastro.Width := 14;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'cadastro:';
    lbcadastro.Transparent := True;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 221;
    edcadastro.Top := 567;
    edcadastro.Width := 200;
    edcadastro.Height := 21;
    edcadastro.Enabled := True;
    edcadastro.TabOrder := 20;
    edcadastro.Text := 'edcadastro';
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 597;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 594;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 21;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 624;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 621;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 22;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 651;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 648;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 23;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 678;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 675;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 24;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 705;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 702;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 25;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Grade_ProdutosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Grade_ProdutosDataset.SetParentComponent(Self);
    Grade_ProdutosDataset.Name := 'Grade_ProdutosDataset';
    Grade_ProdutosDataset.AfterApplyUpdates := Grade_ProdutosDatasetAfterApplyUpdates;
    Grade_ProdutosDataset.EntitySetName := 'Grade_Produtos';
    Grade_ProdutosDataset.Connection := DMConnection.ApiConnection;
    Grade_ProdutosDataset.Left := 176;
    Grade_ProdutosDataset.Top := 8;
    Grade_ProdutosDatasetid.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetid.Name := 'Grade_ProdutosDatasetid';
    Grade_ProdutosDatasetid.FieldName := 'id';
    Grade_ProdutosDatasetid.Required := True;
    Grade_ProdutosDatasetaliado_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetaliado_id.Name := 'Grade_ProdutosDatasetaliado_id';
    Grade_ProdutosDatasetaliado_id.FieldName := 'aliado_id';
    Grade_ProdutosDatasetaliado_id.Required := True;
    Grade_ProdutosDatasetdata_base_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetdata_base_id.Name := 'Grade_ProdutosDatasetdata_base_id';
    Grade_ProdutosDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_ProdutosDatasetdata_base_id.Required := True;
    Grade_ProdutosDatasetgrade_linha_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetgrade_linha_id.Name := 'Grade_ProdutosDatasetgrade_linha_id';
    Grade_ProdutosDatasetgrade_linha_id.FieldName := 'grade_linha_id';
    Grade_ProdutosDatasetgrade_linha_id.Required := True;
    Grade_ProdutosDatasetgrade_coluna_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetgrade_coluna_id.Name := 'Grade_ProdutosDatasetgrade_coluna_id';
    Grade_ProdutosDatasetgrade_coluna_id.FieldName := 'grade_coluna_id';
    Grade_ProdutosDatasetgrade_coluna_id.Required := True;
    Grade_ProdutosDatasetprodutos_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetprodutos_id.Name := 'Grade_ProdutosDatasetprodutos_id';
    Grade_ProdutosDatasetprodutos_id.FieldName := 'produtos_id';
    Grade_ProdutosDatasetprodutos_id.Required := True;
    Grade_ProdutosDatasetnome.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetnome.Name := 'Grade_ProdutosDatasetnome';
    Grade_ProdutosDatasetnome.FieldName := 'nome';
    Grade_ProdutosDatasetnome.Required := True;
    Grade_ProdutosDatasetnome.Size := 255;
    Grade_ProdutosDatasetcodigo_barras.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_barras.Name := 'Grade_ProdutosDatasetcodigo_barras';
    Grade_ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    Grade_ProdutosDatasetcodigo_barras.Required := False;
    Grade_ProdutosDatasetcodigo_barras.Size := 255;
    Grade_ProdutosDatasetcodigo_fabrica.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_fabrica.Name := 'Grade_ProdutosDatasetcodigo_fabrica';
    Grade_ProdutosDatasetcodigo_fabrica.FieldName := 'codigo_fabrica';
    Grade_ProdutosDatasetcodigo_fabrica.Required := False;
    Grade_ProdutosDatasetcodigo_fabrica.Size := 255;
    Grade_ProdutosDatasetestoque.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque.Name := 'Grade_ProdutosDatasetestoque';
    Grade_ProdutosDatasetestoque.FieldName := 'estoque';
    Grade_ProdutosDatasetestoque.Required := False;
    Grade_ProdutosDatasetestoque_retido.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_retido.Name := 'Grade_ProdutosDatasetestoque_retido';
    Grade_ProdutosDatasetestoque_retido.FieldName := 'estoque_retido';
    Grade_ProdutosDatasetestoque_retido.Required := True;
    Grade_ProdutosDatasetestoque_maximo.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_maximo.Name := 'Grade_ProdutosDatasetestoque_maximo';
    Grade_ProdutosDatasetestoque_maximo.FieldName := 'estoque_maximo';
    Grade_ProdutosDatasetestoque_maximo.Required := False;
    Grade_ProdutosDatasetestoque_minimo.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_minimo.Name := 'Grade_ProdutosDatasetestoque_minimo';
    Grade_ProdutosDatasetestoque_minimo.FieldName := 'estoque_minimo';
    Grade_ProdutosDatasetestoque_minimo.Required := False;
    Grade_ProdutosDatasetstatus.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetstatus.Name := 'Grade_ProdutosDatasetstatus';
    Grade_ProdutosDatasetstatus.FieldName := 'status';
    Grade_ProdutosDatasetstatus.Required := True;
    Grade_ProdutosDatasetcadastro.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcadastro.Name := 'Grade_ProdutosDatasetcadastro';
    Grade_ProdutosDatasetcadastro.FieldName := 'cadastro';
    Grade_ProdutosDatasetcadastro.Required := False;
    Grade_ProdutosDatasetcodigo_interno.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_interno.Name := 'Grade_ProdutosDatasetcodigo_interno';
    Grade_ProdutosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_ProdutosDatasetcodigo_interno.Required := True;
    Grade_ProdutosDatasetexcluido.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetexcluido.Name := 'Grade_ProdutosDatasetexcluido';
    Grade_ProdutosDatasetexcluido.FieldName := 'excluido';
    Grade_ProdutosDatasetexcluido.Required := False;
    Grade_ProdutosDatasetinclusao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetinclusao.Name := 'Grade_ProdutosDatasetinclusao';
    Grade_ProdutosDatasetinclusao.FieldName := 'inclusao';
    Grade_ProdutosDatasetinclusao.Required := False;
    Grade_ProdutosDatasetalteracao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetalteracao.Name := 'Grade_ProdutosDatasetalteracao';
    Grade_ProdutosDatasetalteracao.FieldName := 'alteracao';
    Grade_ProdutosDatasetalteracao.Required := False;
    Grade_ProdutosDatasetexclusao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetexclusao.Name := 'Grade_ProdutosDatasetexclusao';
    Grade_ProdutosDatasetexclusao.FieldName := 'exclusao';
    Grade_ProdutosDatasetexclusao.Required := False;
    XDataClientGrade_ProdutosGet.SetParentComponent(Self);
    XDataClientGrade_ProdutosGet.Name := 'XDataClientGrade_ProdutosGet';
    XDataClientGrade_ProdutosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_ProdutosGet, Self, 'OnLoad', 'XDataClientGrade_ProdutosGetLoad');
    XDataClientGrade_ProdutosGet.Left := 64;
    XDataClientGrade_ProdutosGet.Top := 8;
    XDataClientGrade_ProdutosDelete.SetParentComponent(Self);
    XDataClientGrade_ProdutosDelete.Name := 'XDataClientGrade_ProdutosDelete';
    XDataClientGrade_ProdutosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_ProdutosDelete, Self, 'OnLoad', 'XDataClientGrade_ProdutosDeleteLoad');
    SetEvent(XDataClientGrade_ProdutosDelete, Self, 'OnError', 'XDataClientGrade_ProdutosDeleteError');
    XDataClientGrade_ProdutosDelete.Left := 64;
    XDataClientGrade_ProdutosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbgrade_linha_id.AfterLoadDFMValues;
    edgrade_linha_id.AfterLoadDFMValues;
    lbgrade_coluna_id.AfterLoadDFMValues;
    edgrade_coluna_id.AfterLoadDFMValues;
    lbprodutos_id.AfterLoadDFMValues;
    edprodutos_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo_barras.AfterLoadDFMValues;
    edcodigo_barras.AfterLoadDFMValues;
    lbcodigo_fabrica.AfterLoadDFMValues;
    edcodigo_fabrica.AfterLoadDFMValues;
    lbestoque.AfterLoadDFMValues;
    edestoque.AfterLoadDFMValues;
    lbestoque_retido.AfterLoadDFMValues;
    edestoque_retido.AfterLoadDFMValues;
    lbestoque_maximo.AfterLoadDFMValues;
    edestoque_maximo.AfterLoadDFMValues;
    lbestoque_minimo.AfterLoadDFMValues;
    edestoque_minimo.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Grade_ProdutosDataset.AfterLoadDFMValues;
    Grade_ProdutosDatasetid.AfterLoadDFMValues;
    Grade_ProdutosDatasetaliado_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetdata_base_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetgrade_linha_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetgrade_coluna_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetprodutos_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetnome.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_fabrica.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_retido.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_maximo.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_minimo.AfterLoadDFMValues;
    Grade_ProdutosDatasetstatus.AfterLoadDFMValues;
    Grade_ProdutosDatasetcadastro.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_ProdutosDatasetexcluido.AfterLoadDFMValues;
    Grade_ProdutosDatasetinclusao.AfterLoadDFMValues;
    Grade_ProdutosDatasetalteracao.AfterLoadDFMValues;
    Grade_ProdutosDatasetexclusao.AfterLoadDFMValues;
    XDataClientGrade_ProdutosGet.AfterLoadDFMValues;
    XDataClientGrade_ProdutosDelete.AfterLoadDFMValues;
  end;
end;

end.
